import * as React from "react"
import { SVGProps } from "react"

function SVGComponent(props: SVGProps<SVGSVGElement>) {
    return (
        <svg width="113" height="27" viewBox="0 0 113 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="113" height="27" rx="13.5" fill="#037E0B"/>
                <text 
                    x="50%" 
                    y="40%" 
                    fill="white" 
                    font-size="16" 
                    font-family="Roboto, sans-serif" 
                    font-weight="600" 
                    text-anchor="middle" 
                    dominant-baseline="central"
                    dy="0.2em">Processed
                </text>
        </svg>
    );
}

export default SVGComponent;